<body>
  <ng-template [ngIf]="userData.isLoggedIn" [ngIfElse]="loggedOut">

    <div *ngIf="userData.isLoggedIn  && userData.role==userRole.Admin">
      <mat-toolbar class="main-toolbar" style="background-color: #2D7C8E;">
         <button mat-icon-button (click)="snav.toggle()" style="color:white;" *ngIf="isMobile"> 
          <mat-icon>menu</mat-icon>
          </button>   
     
        <a style="text-align:left;margin-left:10px;"><img class="imgs" src="assets/img/logo.png"></a>

        <span style="margin-left:20px;color:white;" s>Welcome<b style="color:whitesmoke;margin-left:10px;">{{userData.fullName}}</b> </span>


      </mat-toolbar>

      <mat-sidenav-container class="main-container" >
        
         <mat-sidenav #snav [mode]="sidenavMode" [opened]="!isMobile" class="main-sidenav">
        
          <app-admin-side></app-admin-side>
        </mat-sidenav>

        <mat-sidenav-content class="main-content">

         <div class="sidenav-content">
          <router-outlet></router-outlet>
        </div>                 
        </mat-sidenav-content>
      </mat-sidenav-container>

    </div>
    <!----------------

M A N A G E R  


    -->


    <div *ngIf="userData.isLoggedIn  && userData.role==userRole.Manager">
      <mat-toolbar class="app-toolbar" style="background-color:black;">
        <button mat-icon-button (click)="snav.toggle()" style="color:white;"><mat-icon>menu</mat-icon></button>
        <a style="text-align:left;margin-left:10px;"><img class="imgs" src="assets/img/logo.png"></a>

        <span style="margin-left:20px;color:white;" s>Welcome<b style="color:blue;margin-left:10px;">{{userData.fullName}}</b> </span>


      </mat-toolbar>

      <mat-sidenav-container class="mat-sidenav-container" >
        <mat-sidenav #snav opened mode="side" style="margin-top:0px;">
          <app-manager-side></app-manager-side>
        </mat-sidenav>

        <mat-sidenav-content class="sidenave-content">

          <router-outlet></router-outlet>

        </mat-sidenav-content>
      </mat-sidenav-container>

    </div>


    <!----------------

    M
    A
    N
    A
    G
    E
    R


  -->
    <div *ngIf="userData.isLoggedIn  && userData.role==userRole.User  && !quizStatus">        
       
      <mat-toolbar class="main-toolbar" style="background-color: #2D7C8E;">
        <button mat-icon-button (click)="snav.toggle()" style="color:white;" *ngIf="isMobile">          
          <mat-icon>menu</mat-icon>        
        </button>

        <a ><img img class="imgs" src="assets/img/logo.png"></a>

        <span style="margin-left:10px;color:white;">Welcome<b style="color: #FFFFFF; margin-left: 5px;font-family:Tahoma">{{userData.fullName}}</b> </span>

      </mat-toolbar>
     


      <mat-sidenav-container class="main-container ">
        
        <mat-sidenav #snav [mode]="sidenavMode" [opened]="!isMobile" class="main-sidenav">
        <!----
        <mat-sidenav #snav [mode]="sidenavMode" [opened]="!isMobile" class="main-sidenav" [@slideInOut]>
         <mat-sidenav #snav opened mode="side" style="margin-top:0px;" class="main-sidenav">
        -->
       
          <div *ngIf="userData.isLoggedIn && userData.role==userRole.User">
            <app-user-side></app-user-side>
          </div>
        </mat-sidenav>
             
        <!-- Backdrop element with fade animation and close on click -->
        <div *ngIf="isMobile && snav.opened" @backdropFade class="custom-backdrop" (click)="snav.close()"></div>

        <!-- Backdrop element with fade animation -->
         <!---
          <div *ngIf="isMobile && snav.opened" @backdropFade class="custom-backdrop"></div>
         -->
       


        <mat-sidenav-content class="main-content">
          
        <div class="sidenav-content">
          <router-outlet></router-outlet>
        </div>       

        </mat-sidenav-content>
        
      </mat-sidenav-container>

      
    </div>
    <div *ngIf="userData.isLoggedIn  && userData.role==userRole.User && quizStatus">
      <router-outlet></router-outlet>
    </div>

    <div *ngIf="userData.isLoggedIn && userData.role!=userRole.Admin && userData.role!=userRole.User && userData.role!=userRole.Manager">
      <app-nav-menu></app-nav-menu>
      <router-outlet></router-outlet>
    </div>
  </ng-template>
  <ng-template #loggedOut>
    <div *ngIf="!userData.isLoggedIn">
      <app-nav-menu></app-nav-menu>
      <router-outlet></router-outlet>
    </div>
  </ng-template>
</body>
